<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/c9pxto/tc-custom/9781250031051.jpg?1744296517002" alt="This image is the cover for the book Edge of Normal, Reeve LeClaire Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Edge of Normal, Reeve LeClaire Series
      </h1>
      <p class="bookDescription body article font2">
        <b>“A fast-paced novel of psychological suspense . . . a perfect blend of literary style, psychological insight, and edge-of-the-seat thriller.” —Jeffery Deaver, <i>New York Times</i>–bestselling author</b><br/><br/>In many ways, Reeve LeClaire looks like a typical twenty-two-year-old girl. She’s finally landed her own apartment, she waitresses to pay the bills, and she wishes she wasn’t so nervous around new people. She thinks of herself as agile, not skittish. As serious, not grim. But Reeve is anything but normal.<br/><br/>Ten years ago, she was kidnapped and held captive. After a lucky escape, she’s spent the last six years trying to rebuild her life, a recovery thanks in large part to her indispensable therapist Dr. Ezra Lerner. But when he asks her to help another girl rescued from a similar situation, Reeve realizes she may not simply need to mentor this young victim—she may be the only one who can protect her from a cunning predator who is still out there, watching every move.<br/><br/>From the author of the #1 nonfiction bestseller <i>Perfect Victim: The True Story of the Girl in the Box</i> comes a novel that draws you into a chilling and engrossing world. With masterful plot twists and shifting points of view that make it as irresistible as <i>Gone Girl</i>, Carla Norton’s <i>The Edge of Normal </i>is a stunning debut thriller.<br/><br/><b>“A nail-biter.” —<i>People</i></b><br/><br/><b>“Told with exceptional insight and a Hitchcock-like capacity for suspense, it shows Norton could become one of the finest female thriller writers of her generation.” —<i>Daily Mail</i></b><br/><br/><b>“A page-turner with . . . the psychological depth of Jonathan Kellerman at his best.” —<i>Booklist</i> (starred review)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carla Norton
      </h2>
      
      <p class="authorDescription body article">CARLA NORTON<B></B>is the author of the #1 <I>New York Times</I> bestseller <I>Perfect Victim, </I>which the FBI put on their Behavioral Sciences Unit reading list. She served as the special sections editor for the San Jose Mercury News and has written for numerous publications. She has an MFA from Goddard College and has twice served as a judge for the Edgar Awards. <I>The Edge of Normal, </I>which won a Royal Palm Literary Award for best unpublished mystery, is her debut novel. She lives in California and Florida.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78bc9fa7